import PhoneBook from './components/Table';

function App() {
  return (
    <div className="App">
      <PhoneBook />
    </div>
  );
}

export default App;
